/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Confirmed_By_TitleInputs */

const en_cad_confirmed_by_title = /** @type {(inputs: Cad_Confirmed_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who confirmed the new date?`)
};

const ja_cad_confirmed_by_title = /** @type {(inputs: Cad_Confirmed_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい日程を確認したのは誰ですか？`)
};

const fr_cad_confirmed_by_title = /** @type {(inputs: Cad_Confirmed_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui a confirmé la nouvelle date ?`)
};

const de_cad_confirmed_by_title = /** @type {(inputs: Cad_Confirmed_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer hat den neuen Termin bestätigt?`)
};

/**
* | output |
* | --- |
* | "Who confirmed the new date?" |
*
* @param {Cad_Confirmed_By_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_confirmed_by_title = /** @type {((inputs?: Cad_Confirmed_By_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Confirmed_By_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_confirmed_by_title(inputs)
	if (locale === "ja") return ja_cad_confirmed_by_title(inputs)
	if (locale === "fr") return fr_cad_confirmed_by_title(inputs)
	return de_cad_confirmed_by_title(inputs)
});